import type { LogoOwnerTarget } from '@UI/Pages/Administration/Organizations/Signals/logoSidebarSignal';
import { createSignal } from '@verclam/pulsar';

/** `null` when no logo removal is pending confirmation; otherwise the owner whose logo to remove. */
const logoToRemoveSignal = createSignal<LogoOwnerTarget | null>(null);

export const requestLogoRemoval = (target: LogoOwnerTarget): void => {
	logoToRemoveSignal.value = target;
};

export const cancelLogoRemoval = (): void => {
	logoToRemoveSignal.value = null;
};

export default logoToRemoveSignal;
